import React, { useState } from "react";

const Support = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    
 {
  question: "How does selling a listing work?",
  answer:
    "When you create a listing, it becomes visible on the marketplace for other operators to view. Once a buyer completes payment securely through Stripe, funds are held safely until both parties confirm that the client handover has been completed. After confirmation, payment is released to the seller."
},
    {
      question: "How does buying a listing work?",
      answer:
        "When you purchase a listing, payment is processed securely via Stripe. Seller contact details are unlocked after successful payment. Funds remain protected until both buyer and seller confirm that the client handover has been completed.",
    },
    
{
  question: "When does the seller get paid?",
  answer:
    "Funds are released only after both parties confirm that the client handover has been completed. To receive payment, sellers must have a Stripe account connected to their profile. Stripe registration is free and part of the setup process. If Stripe is not connected, the Dashboard will notify you and prompt you to complete onboarding before you can receive payouts. This structure protects both buyer and seller and helps reduce the risk of disputes."
},

{
  question: "Why have I not received payment after handover has been completed?",
  answer:
    "Funds are only released after both the buyer and seller confirm that the client handover has been successfully completed. If you have confirmed but have not received payment, it may be because the other party has not yet confirmed, your Stripe account is not fully onboarded, or Stripe is still processing the payout (typically 1–3 business days depending on your bank). Please ensure your Stripe account is connected and fully verified in your Dashboard. If everything appears complete and payment is still delayed, contact support and include your listing ID so we can review the transaction logs."
},
    {
  question: "How do swaps work?",
  answer:
    "When one operator sends a swap request, the receiving operator has 72 hours to accept or decline. If accepted, both parties must pay the swap fee through Stripe to confirm commitment. Contact details are unlocked only after both payments are completed. If one party fails to complete payment, the paying party may request a manual refund. Once contact details are unlocked, swap fees are non-refundable. After both users confirm the client handover, the swap is marked complete."
},

    {
      question: "What happens if someone does not confirm handover?",
      answer:
        "If one party fails to confirm handover, the transaction remains pending. Our system logs all actions and timestamps. In rare cases of disputes, both parties may be contacted for clarification.",
    },
    {
      question: "Are payments secure?",
      answer:
        "Yes. All payments are processed securely via Stripe. Client Exchange does not store your card details. Stripe provides industry-standard encryption and payment protection.",
    },
    {
      question: "Why do I need to verify my business?",
      answer:
        "Verification ensures only genuine operators can buy, sell or swap clients. This protects the integrity of the marketplace and builds trust between users.",
    },
    {
  question: "Can I edit or remove my listing?",
  answer:
    "Listings can be edited while active. However, the sale price cannot be changed after a listing is posted, as the listing activation fee is calculated based on the original sale price. Once a sale is completed, the listing is automatically archived and cannot be edited, reactivated, or reposted.",
},
   {
  question: "How long do listings stay active?",
  answer:
    "Listings remain active until sold, swapped, manually removed, or expired. Individual client listings remain active until sold or manually removed because a seller pays an admin listing fee, so they do not automatically expire. Swap listings remain active for 90 days to help keep the marketplace fresh and ensure listings stay current and relevant. If your swap listing expires, you can easily reactivate it from your My Listings section. Reactivation is completely free.",
},
    {
      question: "What fees apply?",
      answer:
        "Fees vary depending on whether you are selling, buying, or swapping. All fees are displayed clearly before checkout so there are no hidden charges.",
    },
    {
      question: "Is my personal information visible?",
      answer:
        "No. Personal contact details are only revealed after payment is completed. This protects users from spam and unsolicited contact.",
    },
  ];

  return (
    <div
      style={{
        padding: "60px 20px",
        maxWidth: "900px",
        margin: "0 auto",
      }}
    >
      <h1
        style={{
          fontSize: "2.8rem",
          fontWeight: "800",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        Support & Frequently Asked Questions
      </h1>

      <p
        style={{
          textAlign: "center",
          marginBottom: "40px",
          color: "#555",
          fontSize: "1.1rem",
        }}
      >
        Everything you need to know about buying, selling and swapping clients
        on Client Exchange.
      </p>

      {faqs.map((faq, index) => (
        <div
          key={index}
          style={{
            marginBottom: "15px",
            borderRadius: "12px",
            boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
            background: "#ffffff",
            overflow: "hidden",
            border: "1px solid #e6e6e6",
          }}
        >
          <div
            onClick={() => toggle(index)}
            style={{
              padding: "18px",
              cursor: "pointer",
              backgroundColor: "#f4faf6",
              fontWeight: "600",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {faq.question}
            <span>{openIndex === index ? "−" : "+"}</span>
          </div>

          {openIndex === index && (
            <div
              style={{
                padding: "18px",
                lineHeight: "1.6",
                color: "#444",
                fontSize: "0.95rem",
              }}
            >
              {faq.answer}
            </div>
          )}
        </div>
      ))}

      <div
        style={{
          marginTop: "50px",
          textAlign: "center",
          padding: "30px",
          backgroundColor: "#f1faf3",
          borderRadius: "14px",
        }}
      >
        <h3 style={{ marginBottom: "10px" }}>Still need help?</h3>
        <p style={{ marginBottom: "10px" }}>
          Contact our support team and we’ll respond as soon as possible.
        </p>
      <p style={{ fontWeight: "600", marginBottom: "4px" }}>
  Client Exchange Pty Ltd
</p>

<p style={{ marginBottom: "8px", color: "#555", fontSize: "0.95rem" }}>
  ABN 23 692 732 157
</p>

<p style={{ fontWeight: "600" }}>
  support@clientexchange.com.au
</p>
      </div>
    </div>
  );
};

export default Support;